import { Box, styled } from '@mui/material'

export const StyledContainer = styled(Box)({
  height: '26px',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '4px',
})
